import { Outlet } from 'react-router-dom'

// TODO... pass on the outlet...
export const Account = () => {
  return <Outlet />
}
